module.exports = __webpack_public_path__ + "static/img/home_index2_yuan.28a405e9.png";